"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import Link from "next/link"
import styles from "../TherapistsPage.module.css"
import { useScrollAnimations } from "../../../hooks/useScrollAnimations"

export default function AdvertiseSection({ getRouteForLeaderOnboarding }) {
  useScrollAnimations(styles, styles.featureCard)
  return [
    <section
      key={"advertise-section"}
      className={styles.featuresSection}
      id="advertise"
      //   style={{
      //     background:
      //       "linear-gradient(180deg, rgba(230, 255, 99, 0.1) 0%, rgba(255, 224, 173, 0.3) 100%)",
      //   }}
    >
      <div className={styles.container}>
        <h2 className={styles.sectionTitle}>Advertise Your Groups</h2>

        <div className={styles.advertiseGrid}>
          <div
            style={{
              background: "white",
              padding: "1.5rem",
              borderRadius: "15px",
              boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
              borderLeft: "5px solid #e6ff63",
            }}
            className={styles.featureCard}
          >
            <h4>📋 Create a Professional Profile</h4>
            <p>
              A big part of running groups is referrals. So we’ve designed a
              comprehensive facilitator profile to showcase your expertise,
              credentials, and approach to build trust and attract the right
              participants.
            </p>
          </div>

          <div
            style={{
              background: "white",
              padding: "1.5rem",
              borderRadius: "15px",
              boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
              borderLeft: "5px solid #e6ff63",
            }}
            className={styles.featureCard}
          >
            <h4>🔗 Share Your Dedicated Group Page</h4>
            <p>
              Set up your group your way—from format, structure and payment. ZestLife
              helps you collect interest. Each listing has a dedicated page where you
              can share details about your group for therapists to make referrals and
              participants to reach out to join your group.
            </p>
          </div>

          <div
            style={{
              background: "white",
              padding: "1.5rem",
              borderRadius: "15px",
              boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
              borderLeft: "5px solid #e6ff63",
            }}
            className={styles.featureCard}
          >
            <h4>🎥 Collaborate on Video Content</h4>
            <p>
              Create engaging introductory videos, educational content, or relatable
              tips to catch the eye of potential participants before they join or
              providers before they refer.
            </p>
          </div>

          <div
            style={{
              background: "white",
              padding: "1.5rem",
              borderRadius: "15px",
              boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
              borderLeft: "5px solid #e6ff63",
            }}
            className={styles.featureCard}
          >
            <h4>💻 Boost Visibility with Marketing Support</h4>
            <p>
              Our intelligent promotion system helps qualified participants discover
              your groups through targeted recommendations and search optimization.
            </p>
          </div>
        </div>
        <h2 className={styles.sectionTitle}>
          Discover new groups you didn’t know existed
        </h2>
        <div className={"text-white text-center text-[19px]"}>
          Sometimes you won’t know there’s a perfect complimentary group that can
          tend to your clients specific needs until you see it.
        </div>
        <div className={"text-white text-center text-[19px] pb-[40px]"}>
          So great groups don’t get buried in list serves, we curate a monthly
          newsletter notifying you of upcoming groups in your area or online.
        </div>
        <div className={""}>
          <div className={styles.ctaSection} style={{ margin: 0 }}>
            <h3
              style={{
                color: "#092c3c",
                fontSize: "1.8rem",
                marginBottom: "1rem",
                fontWeight: "600",
              }}
            >
              Receive curated monthly newsletter{" "}
            </h3>
            <p style={{ fontSize: "1.1rem", color: "#666", marginBottom: "1rem" }}>
              Keep on the look out for groups that could uplift your community,
              clients, or loved ones.
            </p>

            <div
              style={{
                display: "flex",
                gap: "1rem",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <Link href="/signup" className={styles.btnCtaPrimary}>
                Sign up
              </Link>
              <a
                href={getRouteForLeaderOnboarding()}
                className={styles.btnCtaSecondary}
              >
                List my group
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>,
  ]
}
